import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks";
import { getTemplateLinkedComponent } from "./utilities/templateHelpers";
import React from "react";
import { defaultComponents } from "./interfaces/DefaultComponents";
import { getComponentIdentityKey } from "./utilities/componentIdentity";
import { languageCodesEqual } from "./utilities/languageCode";

function CookiePolicyComponent() {
  const cookieTemplates = useAppSelector(
    (state) => state.builder.templates
  ).filter((x) => x.use === "cookiePolicy");
  const [isVisible, setIsVisibile] = useState(true);
  const activePage = useAppSelector((state) => state.builder.pages.active);
  const pageLanguageCode = useAppSelector((state) =>
    state.builder.pages.list.find((x) => x.uuid === activePage)
  )?.languageCode;
  const cookieTemplate = cookieTemplates.find((x) => {
    if (!x.component) return false;

    return languageCodesEqual(x.languageCode, pageLanguageCode);
  });
  const components = useAppSelector(
    (state) => state.builder.structure.components
  );
  let cookieTemplateComponent;

  if (cookieTemplate && components) {
    cookieTemplateComponent = getTemplateLinkedComponent(
      components,
      cookieTemplate
    );
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const handleCookiePolicyShow = () => {
    // Check localstorage if user has agreed to cookies

    const deleteCookie = (cname) => {
      const d = new Date();

      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=; " + expires + "; path=/";
    };

    const setCookie = (cname, cvalue, exdays) => {
      const d = new Date();

      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    };

    deleteCookie("user_cookie_consent");
    setCookie("user_cookie_consent", 1, 30);

    setIsVisibile(false);
  };

  const getElementByClassAsync = (className) => {
    return new Promise((resolve) => {
      const getElement = () => {
        const elements = document.querySelectorAll(`.${className} button`);

        if (elements.length > 0) {
          resolve(elements);
        } else {
          requestAnimationFrame(getElement);
        }
      };

      getElement();
    });
  };

  const componentDidMount = async () => {
    const cookieButtons = await getElementByClassAsync("cookie-policy-popup");

    (cookieButtons as NodeListOf<HTMLButtonElement>).forEach((button) => {
      button.addEventListener("click", handleCookiePolicyShow);
    });

    return () => {
      (cookieButtons as NodeListOf<HTMLButtonElement>).forEach((button) => {
        button.removeEventListener("click", handleCookiePolicyShow);
      });
    };
  };

  useEffect(() => {
    componentDidMount();
  }, [activePage]);

  let cookie_consent = getCookie("user_cookie_consent");

  if (!cookieTemplateComponent) {
    return <></>;
  }

  const ComponentToRender = defaultComponents[cookieTemplateComponent.type];

  if (
    cookie_consent != "" &&
    cookieTemplateComponent.id &&
    cookieTemplateComponent
  ) {
    return <></>;
  } else {
    return (
      <>
        <style>
          {`
      .cookie-policy-popup .container .col {
        pointer-events: all;
      }
    `}
        </style>

        <div
          className="cookie-policy-popup"
          style={{
            position: isVisible ? "fixed" : "unset",
            bottom: "0",
            zIndex: 9,
            width: "100%",
            display: isVisible ? "block" : "none",
            pointerEvents: "none",
          }}
        >
          <ComponentToRender
            {...cookieTemplateComponent}
            key={getComponentIdentityKey(cookieTemplateComponent)}
          />
        </div>
      </>
    );
  }
}

export default CookiePolicyComponent;
